<template>
  <div
    class="chart-data-point"
    :class="{
      'chart-data-point--selected': Boolean(isSelected),
      'chart-data-point--draggable': showDragHandle,
      'chart-data-point--disabled': Boolean(isDisabled)
    }"
    @click="handleClick"
  >
    <!-- Drag Handle (only for Chart Management) -->
    <div
      v-if="showDragHandle"
      class="chart-data-point__drag-handle"
      @mousedown.stop
      @click.stop
    >
      <i class="ri-draggable"></i>
    </div>

    <!-- Checkbox -->
    <div class="chart-data-point__checkbox">
      <div class="advance-reporting-checkbox-container">
        <input
          type="checkbox"
          :id="checkboxId"
          :checked="Boolean(isSelected)"
          :disabled="isDisabled"
          @change="handleCheckboxChange"
          @mousedown.stop
          @click.stop
          class="checkbox-input"
        />
        <div
          class="checkbox-visual"
          :class="{ checked: Boolean(isSelected) && !isDisabled }"
          @mousedown.stop
          @click.stop="handleCheckboxChange"
        >
          <i
            class="ri-check-line"
            v-if="Boolean(isSelected) && !isDisabled"
          ></i>
        </div>
      </div>
    </div>

    <!-- Chart Info -->
    <div class="chart-data-point__info">
      <div class="chart-data-point__name">{{ chartName }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ChartDataPointComponent",
  props: {
    chartId: {
      type: [String, Number],
      required: true
    },
    chartName: {
      type: String,
      required: true
    },
    isSelected: {
      type: [Boolean, Number],
      default: false
    },
    showDragHandle: {
      type: Boolean,
      default: false
    },
    checkboxId: {
      type: [String, Number],
      default: ""
    },
    isDisabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ["toggle", "click"],
  setup(props, { emit }) {
    const handleClick = () => {
      if (props.isDisabled) return
      emit("click", props.chartId)
    }

    const handleCheckboxChange = () => {
      if (props.isDisabled) return
      emit("toggle", props.chartId, !props.isSelected)
    }

    return {
      handleClick,
      handleCheckboxChange
    }
  }
}
</script>
